<template>
<div>
  <v-dialog max-width="95%" persistent no-click-animation scrollable v-model="showDialog">
    <v-card min-height="75%" min-width="95%">
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer/>
        <v-toolbar-title>
          機能一覧
        </v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container class="pa-2" fluid>
          <v-row no-gutters justify="end">
            <span style="color:#1F2B38">各機能右端の</span>
            <v-icon color="#2D71BF" style="margin-top: -1px !important;">mdi-open-in-new</v-icon>
            <span style="color:#1F2B38">を押下すると別タブで開きます</span>
          </v-row>
          <v-row no-gutters>
            <v-col
              :xs="12" :sm="6" :md="6" :lg="3" :xl="3" :cols="12"
              class="pa-2"
              v-for="menu in menuList"
              :key="menu.id"
            >
              <v-row no-gutters>
                <v-col :cols="12">
                  <v-card>
                    <v-card-title class="text-h5 ">
                      <v-icon color="primary">{{ menu.icon }}</v-icon>
                      {{ menu.menuNm }}
                    </v-card-title>
                    <v-divider />
                    <v-card-subtitle class="mt-1 menu-description">
                      {{ menu.menuDescription }}
                    </v-card-subtitle>
                    <v-card-text>
                      <v-row
                        no-gutters
                        v-for="sub in menu.lists"
                        :key="sub.id"
                      >
                        <v-col :cols="12" class="px-1">
                          <v-row no-gutters>
                            <v-col :cols="11">
                              <v-icon>mdi-square-small</v-icon>
                              <router-link @click.native="onRoute()" :to="{ name: sub.viewNm, params: { id: 0 }}">{{ sub.kinoTitle }}</router-link>
                            </v-col>
                            <v-col :cols="1">
                              <router-link class="no-under-line" @click.native="onRoute()" :to="{ name: sub.viewNm, params: { id: 0 }}" target="_blank">
                                <dd-icon-button-with-tooltip
                                  message="別タブで開きます"
                                  icon="mdi-open-in-new"
                                />
                              </router-link>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
// ************************************************************
// <特記事項>
//  mapGetters用のLoadMaster(menuList等の取得)は当コンポーネントを呼び出す画面で実施する事
// ************************************************************
import controls from '@/rahmen/controls'
import flowMixin from '@/mixins/flowMixins'

import { mapGetters } from 'vuex'

const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')

export default {
  name: 'DdFunctionListDialog',
  mixins: [flowMixin],
  components: {
    DdIconButtonWithTooltip
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean
  },
  data: () => ({
    invalidMessage: ''
  }),
  created () {
  },
  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)

    if (this.invalidMessage === undefined) {
      // this[controls.VALIDATE_METHOD]()
    }
  },
  watch: {
    value: function (n, o) {
      this.innerValue = n
    }
  },
  computed: {
    ...mapGetters({
      menuList: 'DDMasters/menuList'
    })
  },
  methods: {
    onRoute: function (e) {
      // this.Effects.loadStart()
      this.$emit('cancelClose', undefined)
    },
    // ----------------------------------------------------------------------------------------------------
    // 閉じるボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCloseClick: function (e) {
      this.$emit('close', undefined)
    }
  }
}
</script>
<style scoped>
.text-h5 {
    padding: .1em .5em;
    margin-top: 6px;
    border-left: 6px solid rgb(47, 117, 181);
}
.no-under-line /deep/ {
    text-decoration: none;
}
.menu-description {
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 2px;
  padding-bottom: 2px;
  font-weight: bold;
  color: #1F2B38 !important;
}
</style>
